// Aus einer Selbstauskunft einen Kontakt vorbelegen (Ticket #375) — die Daten liegen ja schon
// vor. Nur Vorbelegung: das Kontaktformular öffnet sich, die Verwaltung prüft und speichert.

export interface KontaktVorbelegung {
  anrede?: string;
  vorname?: string;
  nachname?: string;
  kontaktart?: string;
  geburtsdatum?: string;
  strasse?: string;
  hausnummer?: string;
  plz?: string;
  stadt?: string;
  email?: string;
  festnetz?: string;
  handynummer?: string;
}

interface Quelle {
  name: string;
  email: string;
  telefon: string | null;
  daten: {
    anrede?: string; vorname?: string; nachname?: string; geburtsdatum?: string;
    strasse?: string; plz?: string; ort?: string; telefon?: string; email?: string;
  };
}

/** „Musterstraße 12a" → Straße + Hausnummer; ohne erkennbare Nummer bleibt alles in der Straße. */
export function trenneStrasse(roh: string | undefined): { strasse: string; hausnummer: string } {
  const s = (roh || '').trim();
  const m = s.match(/^(.*?\D)\s*(\d+\s*[a-zA-Z]?(?:\s*[-/]\s*\d+\s*[a-zA-Z]?)?)$/);
  if (!m || !m[1].trim()) return { strasse: s, hausnummer: '' };
  return { strasse: m[1].trim(), hausnummer: m[2].replace(/\s+/g, '') };
}

/** Deutsche Mobilnummern beginnen mit 015x/016x/017x (auch als +49/0049). */
export function istMobilnummer(nummer: string): boolean {
  const n = nummer.replace(/[^\d+]/g, '').replace(/^(\+|00)49/, '0');
  return /^01[567]/.test(n);
}

export function kontaktAusSelbstauskunft(e: Quelle): KontaktVorbelegung {
  const d = e.daten || {};
  let vorname = (d.vorname || '').trim();
  let nachname = (d.nachname || '').trim();
  if (!vorname && !nachname) {
    // Ältere Eingänge ohne getrennte Felder: letztes Wort = Nachname.
    const teile = (e.name || '').trim().split(/\s+/).filter(Boolean);
    nachname = teile.pop() || '';
    vorname = teile.join(' ');
  }
  const telefon = (d.telefon || e.telefon || '').trim();
  const { strasse, hausnummer } = trenneStrasse(d.strasse);
  const anrede = ['Herr', 'Frau', 'Divers'].includes(d.anrede || '') ? d.anrede : undefined;
  return {
    anrede,
    vorname,
    nachname,
    kontaktart: 'Mieter',
    geburtsdatum: d.geburtsdatum || '',
    strasse,
    hausnummer,
    plz: (d.plz || '').trim(),
    stadt: (d.ort || '').trim(),
    email: (d.email || e.email || '').trim(),
    festnetz: telefon && !istMobilnummer(telefon) ? telefon : '',
    handynummer: telefon && istMobilnummer(telefon) ? telefon : '',
  };
}
